import { createTheme, responsiveFontSizes } from '@mui/material';
import { MuiAccordion } from './new-vy/components/mui-accordion';
import { MuiAccordionSummary } from './new-vy/components/mui-accordion-summary';
import { MuiAutocomplete } from './new-vy/components/mui-autocomplete';
import { MuiButton } from './new-vy/components/mui-button';
import { MuiChip } from './new-vy/components/mui-chip';
import { MuiFilledInput } from './new-vy/components/mui-filled-input';
import { MuiListItemButton } from './new-vy/components/mui-list-item-button';
import { MuiListItemIcon } from './new-vy/components/mui-list-item-icon';
import { MuiListSubheader } from './new-vy/components/mui-list-subheader';
import { MuiPaper } from './new-vy/components/mui-paper';
import { MuiSwitch } from './new-vy/components/mui-switch';
import { MuiTab } from './new-vy/components/mui-tab';
import { MuiTabs } from './new-vy/components/mui-tabs';
import { MuiTextField } from './new-vy/components/mui-text-field';
import { newVyPalette } from './new-vy/palette';
import { newVyShadows } from './new-vy/shadows';
import { newVyTypography } from './new-vy/typography';

export const newVyTheme = responsiveFontSizes(createTheme({
  palette: newVyPalette,
  typography: newVyTypography,
  shadows: newVyShadows,
  components: {
    MuiListItemButton,
    MuiListSubheader,
    MuiAutocomplete,
    MuiListItemIcon,
    MuiAccordion,
    MuiAccordionSummary,
    MuiFilledInput,
    MuiTextField,
    MuiButton,
    MuiSwitch,
    MuiPaper,
    MuiChip,
    MuiTabs,
    MuiTab,
  },
}));